import Auto from "./Auto";

export default Auto;
